import React, { useEffect } from "react";
import Main from "./Main";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { loadGoogleAds } from "./utils/googleAds";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 314,
      smm: 530,
      md: 768,
      lg: 1024,
      xl: 1220,
      xll:1440,
      xxl: 1600,
    },
  },
});

const App = () => {

  useEffect(() => {
    loadGoogleAds('AW-11321518946'); // ✅ Load Google Ads globally
  }, []);

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Main />
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
